import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { HiOutlineChevronDoubleLeft } from 'react-icons/hi';
import cn from 'classnames';
import { Alert } from 'react-bootstrap';

import { Track } from 'services/action';

import { formatDate } from 'utilities/common';
import { Page } from 'ui/components';

import LogoWhiteT from 'ui/assets/envio-white-t.png';
import TableRow from './table.row';
import TableOrder from './table.order';
import Order from './order';
import SplashScreen from 'ui/components/loading';

const TrackScreen = ({ location, match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Track.Show']
  );

  const [order, setOrder] = React.useState(null);
  const [data, setData] = React.useState(null);
  const [total, setTotal] = React.useState(null);

  const $getTracking = async (e) => {
    const req = await Dispatch(Track.$get({ code: e }));

    if (req?.message === 'success') {
      if (req?.data?.order) {
        setOrder(req?.data);
      } else {
        setTotal(req?.total);
        if (req?.total === 1) {
          setData(req?.data?.[0].shipments)
        } else {
          setData(req?.data);
        }
      }
    }
  };

  React.useEffect(() => {
    let code = null;
    if (location?.search) {
      if (location?.search?.includes('?code=')) {
        code = location?.search?.replace('?code=', '');
      }
    } else {
      if (match?.params[0]) {
        code = match?.params[0];
      }
    }

    $getTracking(code);
  }, [match, location]);

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  if (StateLoading)
    return (
      <Page>
        <Page.Body>
          <SplashScreen />;
        </Page.Body>
      </Page>
    );

  return (
    <Page>
      <Page.Body className="">
        <div>
          <div className="container ">
            <div
              className={cn(
                'hr-text hr-text-left text-primary mb-3 mb-md-5',
                'mt-md-5 mt-4'
              )}
            >
              <button
                className="btn btn-action "
                onClick={() => History.replace('/')}
              >
                <HiOutlineChevronDoubleLeft className="me-2" />
                Cari kode lainnya
              </button>
            </div>

            {(!order && !data) ? (
              <Alert variant="danger" className="mb-0">
                <Alert.Heading>Kode tracking tidak ditemukan</Alert.Heading>
              </Alert>
            ): order ? (
              <Order data={order}/>
            ): (
              <div className="table-responsive mt-3">
                <table
                  width="100%"
                  className="table table-hover table-vcenter card-table datatable"
                >
                  <thead className="bg-light">
                    <tr className="th">
                      <th style={{ whiteSpace: 'initial', width: '5%' }}>No</th>
                      <th style={{ whiteSpace: 'initial', width: '20%' }}>
                        {total === 1 ? 'Kode': 'Order'}
                      </th>

                      {total === 1 && (
                        <>
                          <th style={{ whiteSpace: 'initial', width: '30%' }}>
                            Tujuan
                          </th>
                          <th style={{ whiteSpace: 'initial', width: '15%' }}>
                            Tgl Diterima
                          </th>
                          <th style={{ whiteSpace: 'initial', width: '15%' }}>
                            Diterima oleh
                          </th>
                          <th style={{ whiteSpace: 'initial', width: '15%' }}>
                            Status
                          </th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((s, i) => (
                      total === 1 ? (
                        <TableRow data={s} key={i} keys={i} />
                      ): (
                        <TableOrder data={s} key={i} keys={i} />
                      )
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </Page.Body>
      <Page.Footer>
        <footer className="footer bg-primary d-print-none">
          <div className="container py-3 py-md-4">
            <div className="row text-start text-light">
              <div className="col-lg-4">
                <div>
                  <img src={LogoWhiteT} alt="" className="navbar-brand-image" />
                </div>
                <div className="pt-3 mt-n1 pt-md-5">
                  <p className="mb-3 fs-7">
                    Copyright @ {formatDate(new Date(), 'YYYY')} envio.co.id{' '}
                    <br /> All rights reserved.
                  </p>
                </div>
              </div>
              <div className="col-lg-4">
                <div>
                  <p className="mb-0 fw-bolder fs-6">Email</p>
                  <p className="fs-7 mb-0 mb-md-2 pb-md-1">
                    support@envio.co.id
                  </p>
                </div>
                <div className="pt-3 pt-md-4">
                  <p className="mb-0 fw-bolder fs-6">Work Hour</p>
                  <p className="fs-7">Monday - Friday, 09.00 - 21.00 GMT +7</p>
                </div>
              </div>
              <div className="col-lg-4">
                <p className="mb-0 fw-bolder fs-6">Address</p>
                <p className="fs-7">
                  Kinanti Building Lt 2<br /> Jl. Epicentrum Tengah No. 3,
                  Kawasan Rasuna Epicentrum, Karet Kuningan Setiabudi,
                  <br /> Jakarta Selatan 12940
                </p>
              </div>
            </div>
          </div>
        </footer>
      </Page.Footer>
    </Page>
  );
};

export default TrackScreen;
